import React from 'react';

export default function StoryBlobs({ dark }: { dark: boolean }) {
  return (
    <>
      {/* Mountain-like blob top left */}
      {dark ? (
        <svg
          className="absolute top-[-80px] left-[-60px] w-[420px] h-[180px] opacity-10 -z-10 pointer-events-none"
          viewBox="0 0 420 180"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0,180 Q60,80 140,120 Q200,40 320,100 Q400,140 420,60 L420,0 L0,0 Z" fill="#b4befe" />
        </svg>
      ) : (
        <svg
          className="absolute top-[-80px] left-[-60px] w-[420px] h-[180px] opacity-10 -z-10 pointer-events-none"
          viewBox="0 0 420 180"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0,180 Q60,80 140,120 Q200,40 320,100 Q400,140 420,60 L420,0 L0,0 Z" fill="#fab387" />
        </svg>
      )}
      {/* Accent blob bottom right */}
      {dark ? (
        <svg
          className="absolute bottom-[-60px] right-[-40px] w-[320px] h-[120px] opacity-10 -z-10 pointer-events-none"
          viewBox="0 0 320 120"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <ellipse cx="160" cy="60" rx="140" ry="40" fill="#45475a" />
        </svg>
      ) : (
        <svg
          className="absolute bottom-[-60px] right-[-40px] w-[320px] h-[120px] opacity-10 -z-10 pointer-events-none"
          viewBox="0 0 320 120"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <ellipse cx="160" cy="60" rx="140" ry="40" fill="#f9e2af" />
        </svg>
      )}
    </>
  );
}
